module.exports = __webpack_public_path__ + "img/kt2.c27df4b2.png";